import React from 'react';
import styles from './AvatarFields.module.css';
import fieldList from './AvatarFieldsList';

const AvatarFields = ({ index, value, setValue }) => {
    const field = fieldList[index];

    if (!field) return null;

    const { icon, ...inputProps } = field;

    return (
        <div className={styles.option}>
            <img className={styles.icon} src={icon} alt='' />
            <input
                className={styles.field}
                {...inputProps}
                value={value}
                onChange={(e) => !field.readOnly && setValue(e.target.value)}
            />
        </div>
    );
};

export default AvatarFields;
